import React from 'react';
import useDocumentTitle from './useDocumentTitle'
import NavbarDiscuss from './navbarDiscuss';

export default function Learn() {
  useDocumentTitle("101Discuss | FRC101 by the Spartabots")
  return (
    <div class="h-screen static overflow-hidden">
      <NavbarDiscuss />
      <div>
        <section class="pt-2.5 flex max-w-[150rem] mx-auto h-screen bg-tempDiscuss bg-no-repeat bg-center justify-center">
          <div class="relative top-[40%] rounded-[0.5rem] mx-36 my-10">
            {/* <img src={image} class="my-5 rounded-[1rem]" alt="Discuss redirect"></img> */}
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSecbmz-bhcG6uKaDDHXRIDf9tYDbEXbRCXp1bZaeL-Oftcqrw/viewform?embedded=true" target="_blank" rel="noreferrer" class="font-productsans font-bold text-4xl text-white">
              <div class="p-5 rounded-[0.5rem] shadow-lg bg-frcyellow hover:bg-frcblue duration-300 my-5 text-center"><p>Contact Form</p></div>
            </a>
          </div>
        </section>
      </div>
    </div>
  )
}